<template>
  <div class="com-container2">
    <div class="swiper-wrapper commonBoder">
      <el-carousel :interval="3000" indicator-position="none">
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <img :src="item.url" alt="" srcset="" />
          <div class="textDesc">
            <p>{{ item.name }}</p>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import swiper1 from '../assets/images/【诊改行动】变革创新，激情奋起！上电智联助力正式开启双菊汽配轻量级数字化改造项目.jpg'
import swiper2 from '../assets/images/大洋精锻盐智钉项目启动会.jpg'
import swiper3 from '../assets/images/艾匹柯流体设备盐智钉项目启动会.jpg'
import swiper4 from '../assets/images/【诊改行动】乘“数”而上，“捷”足先登！上电智联助力大捷实业开启轻量级数字化改造项目.jpg'
import swiper5 from '../assets/images/【诊改行动】大步迈进，扬“威”智造新局面！上电智联助力盖威新能源开启轻量级数字化改造项目.jpg'
import swiper6 from '../assets/images/【诊改行动】合作升级，共驱共赢！上电智联助力爱驰威开启轻量级数字化改造项目.jpg'
import swiper7 from '../assets/images/【诊改行动】数“智”赋能，“阳”帆启航！上电智联助力阳城汽配启动轻量级数字化改造项目.jpg'
import swiper8 from '../assets/images/【诊改行动】数实融合，共谋新篇！上电智联助力阳光能源开启主数据系统项目.jpg'
import swiper9 from '../assets/images/【诊改行动】携手同行，聚势共赢！上电智联助力盐发机械开启轻量数字化改造项目.jpg'
export default {
  data() {
    return {
      swiperList: [
        { name: '双菊汽配轻量级数字化改造项目', url: swiper1 },
        { name: '大洋精锻盐智钉项目启动会', url: swiper2 },
        { name: '艾匹柯流体设备盐智钉项目启动会', url: swiper3 },
        { name: '大捷实业开启轻量级数字化改造项目', url: swiper4 },
        { name: '盖威新能源开启轻量级数字化改造项目', url: swiper5 },
        { name: '爱驰威开启轻量级数字化改造项目', url: swiper6 },
        { name: '阳城汽配启动轻量级数字化改造项目', url: swiper7 },
        { name: '阳光能源开启主数据系统项目', url: swiper8 },
        { name: '盐发机械开启轻量数字化改造项目', url: swiper9 }
      ]
    }
  },
  mounted() {

  },
  methods: {}
}
</script>
<style lang="less">
.com-container2 {
  padding: 10px;

  .el-carousel__container {
    height: 250px !important;
  }
}
</style>

<style lang="less" scoped>
.com-container {
  display: flex;
  justify-content: center;

}

.textDesc {
  position: absolute;
  bottom: 0;
  z-index: 10;
  background-color: rgba(#000000, 0.2);
  width: 100%;
  padding: 4px;

  p {
    color: #ffffff;
    font-size: 24px;
    letter-spacing: 1px;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
